export default {
  automaticBooking: {
    actions: {
      confirmAppointment: 'Confirm appointment',
      createManualBooking: 'Create manual booking',
    },
    description:
      "Choose a time slot that works best for you. If you don't see a time slot that you like, create a manual booking.",
    header: 'Select a different time slot',
  },
  bookWithReferral: {
    actions: {
      checkReferralCode: 'Check referral code',
    },
    caption:
      'You can find the referral code in the referral letter. The code starts with ‘ZD’ followed by 9 digits.',
    dateOfBirth: {
      label: 'Date of birth',
      placeholder: 'dd/mm/yyyy',
    },
    errorMessage: {
      dateOfBirth: 'Date of birth is required',
      internalServerError: 'Internal server error. Please try again later.',
      networkError:
        'Network error. Please check your connection and try again.',
      notFound: 'Referral code not found',
      referralCode: "Referral code must be 'ZD' followed by 9 digits",
      underage:
        'Xpert Clinics does not accept patients under the age of 18 for this treatment. Please contact your referring doctor if you have any questions.',
      unexpectedError: 'An unexpected error occurred. Please try again later.',
    },
    header: 'Book with referral code',
    referralCode: {
      label: 'Referral code',
      placeholder: 'ZD123456789',
    },
  },
  confirmBooking: {
    actions: {
      changeAppointment: 'Change appointment',
      confirmBooking: 'Confirm appointment',
    },
    breadcrumbLink: 'Select date and time',
    header: 'Confirm details',
    selectDifferentTimeslot: 'Select a different timeslot',
  },
  confirmDetails: {
    actions: {
      continue: 'Continue',
      edit: 'Edit details',
    },
    description:
      'Are the following personal details correct? If not, please update your email address and telephone number accordingly.',
    editDetails: {
      actions: {
        saveAndContinue: 'Save and continue',
      },
      email: {
        label: 'Email address',
        placeholder: 'Enter your email address',
      },
      telephone: {
        label: 'Telephone number',
        placeholder: 'XXX-XXX XXXX',
      },
    },
    header: 'Confirm your details',
  },
  moreInformation: {
    actions: {
      continue: 'Continue',
    },
    description:
      'Please answer the following questions so that we can book the correct appointment for you',
    header: 'We need more information',
  },
  proposedAppointment: {
    actions: {
      confirmAppointment: 'Confirm appointment',
      selectTimeSlot: 'Select a different time slot',
    },
    description:
      'If the following proposed appointment doesn’t work for you, select a different time slot.',
    error: 'An error occurred while fetching the appointment slots.',
    header: 'Proposed appointment',
  },
  referralNotFound: {
    actions: {
      call: 'Call',
      cancel: 'Cancel',
    },
    body: 'If you think this is a mistake, please call us at {{phone}}',
    title: 'Referral not found',
  },
  referralSelection: {
    actions: {
      no: 'No',
      yes: 'Yes',
    },
    caption:
      'You can find the referral code in the referral letter. The code starts with ‘ZD’ followed by 9 digits.',
    header: 'Do you have a referral code?',
    noReferralModal: {
      actions: {
        call: 'Call',
        cancel: 'Cancel',
      },
      body: `To continue, please enter your referral code. If you don’t have one or need help, please call us at {{phone}}`,
      title: 'You need a referral code to book an appointment',
    },
  },
  selectClinic: {
    actions: {
      selectTimeSlot: 'Select time slot',
    },
    breadcrumbLink: 'Back',
    closestClinic: 'Choose clinic closest to you ',
    firstAvailability: 'First available: {{date}}',
    header: 'Select Clinic',
    selectDoctor: 'Select doctor',
    showingDistance: 'Showing results sorted by distance',
    subheader: 'Search clinics',
    switchLabel: 'Find the clinic nearest to you. This can be changed later.',
    zipCodeInvalid: '*Invalid ZIP code',
    zipCodeLabel: 'ZIP Code',
  },
  selectDateTime: {
    actions: {
      reviewBooking: 'Review booking',
    },
    breadcrumbLink: 'Select location',
    dropdownDoctors: {
      all: 'Show All',
      label: 'Select a doctor',
    },
    header: 'Select date and time',
    noSlots: 'No available slots for the selected location',
    showAllSlots: 'Show all clinician timeslots',
  },
}
